<div class="snackbar-container">
  <mat-icon
    class="report-icon"
    svgIcon="ic-alert"
    aria-hidden="false"
    aria-label="Alert icon"
  ></mat-icon>
  <span class="message"> {{ this.message$ | async }} </span>
</div>
